import { routeConfig as trainingRouteConfig } from './training';
import { routeConfig as releaseNotesRouteConfig } from './releaseNotes';

export default function routes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider.when(
    '/support',
    {
      redirectTo: '/support/tickets'
    }
  ).when(
    '/training',
    trainingRouteConfig
  ).when(
    '/support/releasenotes',
    releaseNotesRouteConfig
  );
}

routes.$inject = ['$routeProvider', '$locationProvider'];
console.log('app.components.support.routes loaded');
